import Image from 'app/Components/Shared/Image/image';
import TextInputWithPrefix from "app/Components/Shared/TextInputWithPrefix/TextInputWithPrefix";
import Config from "app/Config";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import PopUp from "app/Components/Shared/Popup/PopUp";
import ConfirmationPopUp from "app/Components/Block/SimReplacementBlock/popUps/ConfirmationPopUp";
import {InfoPopUp} from "app/Components/Block/SimReplacementBlock/popUps/InfoPopUp";
import React, {useEffect, useRef, useState} from "react";
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {connect} from "react-redux";
import {
    getSubscribers, handleSetError, replaceSim, setCurrentStep,
    setSubscriber, simNumberAvailabilityCheck,
    simReplacementInit, setSimNumber
} from "app/Components/Block/SimReplacementBlock/simReplacementSlice";
import {
    dwhContinueButton,
    dwhDisplaySimNumberInputPage,

} from "app/Components/Block/SimReplacementBlock/reports/dwhReports";

const SimReplacementStep = (props) => {
    const [simNumber, setSimNumber] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [popUp, setPopUp] = useState("");
    const [checked, setChecked] = useState(false);
  const lengthToCheck = 10;


    useEffect(() => {
        if (simNumber?.length === lengthToCheck) {
            validateInput();
        }
    }, [simNumber]);

    useEffect(() => {
        dwhDisplaySimNumberInputPage(props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData?.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan)

    }, [])

    const handleSubmit = () => {
        handleSetError(false)
        if (simNumber.length < lengthToCheck || errorMessage !== "") {
            handleSetError(true);
        } else {
            dwhContinueButton(props.simReplacementState?.simNumber, props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData?.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan)
            setPopUp('confirmation');
        }
    }

    const handleSetError = (bool) => {
        bool ? setErrorMessage('מספר ה-SIM שהקלדת לא תקין,  אולי חסרה ספרה?') : setErrorMessage('')
    }

    const handleSimNumberChange = (e) => {
        if (errorMessage !== "") {
            handleSetError(false);
        }
        try {
            if (e.target.value === "" || /^[0-9]+$/.test(e.target.value)) {
                setSimNumber(e.target.value);
            }
        } catch (error) {
            props.handleSetError("GENERAL");
        }
    };

    const checkSimNumberAvailability = async () => {
        if (simNumber?.length === lengthToCheck) {
            try {
                const result = await props.simNumberAvailabilityCheck(simNumber);
                if (result && result.payload.Body.isSuccess) {
                    handleSetError(false)
                    props.setSimNumber(simNumber);
                } else {
                    handleSetError(true)
                }
            } catch (error) {
                props.handleSetError("GENERAL");
            }
        } else {
            handleSetError(false)
            setChecked(!checked);
        }
    };

    const validateInput = async () => {
      await checkSimNumberAvailability();
    }


    const handleDisplayHelpPopUp = () => {
        setPopUp('info');
    }

    const handleClosePopUp = () => {
        setPopUp("");
    }

    return (
        <div className={'content'}>
            <div className={'top-content'}>
                <div className={'top-title'}>
                    {props.iContent?.title?.value}
                    <>
                        <div className={'vertical-divider'}/>
                        <span>
                          {' '} למנוי{' '}
                            {props.simReplacementState.subscriber}
                                </span>
                    </>
                </div>
                <span className={'main-title'}>{props.iContent?.subTitle?.value}</span>
            </div>
            <div className={'field'}>
                <p className={'input-title'}>
                    {props.iContent?.fieldTitle?.value}
                </p>
                <div className={'input'}>
                    <TextInputWithPrefix
                      prefixText={Config.simActivationCodePrefix}
                        type='tel'
                      maxLength={'10'}
                        autoComplete='off'
                        value={simNumber}
                        onChange={handleSimNumberChange}
                        error={errorMessage}
                    />
                </div>
                <div className='help-text'>
                    איפה רואים את מספר ה-SIM?
                    <a id='display-sim-number-popover' className='question-icon'
                       onClick={handleDisplayHelpPopUp}>
                        <Image src={require('../images/more-info.svg')} alt={"more-info"} />
                    </a>
                </div>
            </div>

            <div className={'info-list'}>
                <div className={'list-item'}>
                    <Image src={Config.epiBaseUrl + props.iContent.mainPageBulletIcon?.value?.url}
                         alt={"info"} />אין להוציא את ה-SIM הישן שנמצא במכשיר עד לסיום הפעלת ה-SIM החדש באתר
                </div>
                <div className={'horizontal-divider'}/>
                <div className={'list-item'}>
                    <Image src={Config.epiBaseUrl + props.iContent.mainPageBulletIcon?.value?.url}
                         alt={"info"} />יש לוודא שהנייד מחובר ל-WiFi עד לסיום התהליך
                </div>
            </div>
            <div className={'bottom-content'}>
                <div className={'field-error'}>
                    {errorMessage}
                </div>
                <BtnSubmit
                    text={props.iContent?.openPopUpButtonText?.value}
                    onclick={handleSubmit}
                />
            </div>
            <PopUp showPopUp={popUp !== ""} onClose={handleClosePopUp}>
                {popUp === "confirmation" &&
                    <ConfirmationPopUp
                        iContent={props.iContent}
                    />}
                {popUp === "info" && <InfoPopUp/>}
            </PopUp>
        </div>);
}

const mapStateToProps = (state) => {
    return {
        simReplacementState: state.SimReplacement,
        userData: state.authentication,
    }
};

const mapDispatchToProps = {
    setSubscriber,
    getSubscribers,
    simReplacementInit,
    setCurrentStep,
    showAppLoader,
    hideAppLoader,
    handleSetError,
    simNumberAvailabilityCheck,
    replaceSim,
    setSimNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimReplacementStep);
